import axios from 'axios';
import Qs from 'qs';
import router from '@/router'
import { Message, Loading } from 'element-ui'; // 消息提示框组件 这个你们可以不用
import { login } from "@/http/api.js";
import { getMetadataKeys } from 'core-js/fn/reflect';
import { refreshToken } from "@/http/api.js";


// export const evidence_url = process.env.API_HOST + '/' + '';  
// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = '/api/';
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = '/api/';
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = '/api/';
};

// 设置请求超时时间
axios.defaults.timeout = 120000;

// 设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 请求拦截
axios.interceptors.request.use(
    config => {
        if(config.url != 'refresh/token'){
            checkjwt(config);
        }
        if (localStorage.getItem('Authorization')) {
            config.headers.common['jwt'] = localStorage.getItem('Authorization');
        }
        if(config.url == '/login/token'){
            config.headers.common['decrypt'] = 'RSA';
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    });



const loseLogin = function(response){
    var string = response.request.responseURL
    let dataCenterUrl = ["/a/govt/warn/synthesize/count", 
                            "/a/govt/relation/count/company/state",
                            "/a/govt/relation/location/list", 
                            "/a/govt/user/tree/region", 
                            "/a/govt/warn/synthesize/count/all/warn", 
                            "/a/govt/assign/task/count/detail", 
                            "/a/govt/warn/synthesize/page", 
                            "/a/govt/relation/warm/company/list"]
    // var localStorageUsername = localStorage.getItem("username")
    var localStoragePassword = localStorage.getItem("password")
    if(localStoragePassword && dataCenterUrl.includes(response.config.url)){
        checkStatus(response.config);
        response.config.headers.jwt = localStorage.getItem("Authorization")
        return 'data'
    }else {
        router.replace({
            path: '/login'
        })
        return;
    }
}
//响应拦截
axios.interceptors.response.use(
    response => {
        if(response.headers.refreshToken){
            let refreshToken = response.headers.refreshToken
            if(refreshToken){
                localStorage.setItem("Authorization", refreshToken);
            }
        }
        if(response.headers.refreshtoken){
            let refreshtoken = response.headers.refreshtoken
            if(refreshtoken){
                localStorage.setItem("Authorization", refreshtoken);
            }
        }
        return response
    },
    error => {
        if (error.response) {
            let code = error.response.data.code
            if(code==404 || code== 405 || code==406){
                loseLogin(error.response)
            }
            switch (error.response.status) {
                case 404:
                    var string = error.response.request.responseURL
                    let dataCenterUrl = ["/a/govt/warn/synthesize/count", 
                                         "/a/govt/relation/count/company/state",
                                         "/a/govt/relation/location/list", 
                                         "/a/govt/user/tree/region", 
                                         "/a/govt/warn/synthesize/count/all/warn", 
                                         "/a/govt/assign/task/count/detail", 
                                         "/a/govt/warn/synthesize/page", 
                                         "/a/govt/relation/warm/company/list"]
                    // var localStorageUsername = localStorage.getItem("username")
                    var localStoragePassword = localStorage.getItem("password")
                    if(localStoragePassword && dataCenterUrl.includes(error.response.config.url)){
                        checkStatus(error.response.config);
                        error.response.config.headers.jwt = localStorage.getItem("Authorization")
                        return 'data'
                    }else {
                        // 返回 401 清除jwt信息并跳转到登录页面
                        if (string != null && string.indexOf('/a/login') != -1) {
                            router.replace({
                                path: '/login'
                            })
                            return;
                        }
                    }

            }
        }
        return Promise.reject(error.response.data)   // 返回接口返回的错误信息
    })


// 封装get方法和post方法


/* get方法，对应get请求
 @param {String} url [请求的url地址]
 @param {Object} params [请求时携带的参数] */

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: {...params,... {
                cache: new Date().getTime() //设置全部get请求加最新毫秒，避免ie缓存
            }}
        }).then(res => {
            resolve(res.data);
            //  Loading.service(true).close();
            //  Message({message: '请求成功', type: 'success'});
        }).catch(err => {
            reject(err.data)
            //jwt过期跳转不弹出加载失败
            if(err.data.request){
                let string = err.data.request.responseURL
                if (string.indexOf('/a/login;JSESSIONID') != -1) {
                    return;
                }
            }
            //Loading.service(true).close();
            Message({ message: '加载失败', type: 'error' });
        })
    });
}


/* post方法，对应post请求 
@param {String} url [请求的url地址] 
@param {Object} params [请求时携带的参数]  */

export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, JSON.stringify(params))
            .then(res => {
                resolve(res.data);
                //  Loading.service(true).close();
                //  Message({message: '请求成功', type: 'success'});
            })
            .catch(err => {
                reject(err.data)
                //jwt过期跳转不弹出加载失败
                if(err.data.request){
                    let string = err.data.request.responseURL
                    if (string.indexOf('/a/login;JSESSIONID') != -1) {
                        return;
                    }
                }
                // Loading.service(true).close();
                Message({ message: '加载失败', type: 'error' });
            })
    });
}

// new-POST
export function newPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            resolve(res.data);
            //  Loading.service(true).close();
            //  Message({message: '请求成功', type: 'success'});
        }).catch(err => {
            reject(err.data)
            //jwt过期跳转不弹出加载失败
            let string = err.data.request.responseURL
            if (string.indexOf('/a/login;JSESSIONID') != -1) {
                return;
            }
            // Loading.service(true).close();
            Message({ message: '加载失败', type: 'error' });
        })
    });
}

/* post方法，参数序列化
@param {String} url [请求的url地址] 
@param {Object} params [请求时携带的参数]  */

export function qspost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, Qs.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(res => {
                resolve(res.data);
                //  Loading.service(true).close();
                //  Message({message: '请求成功', type: 'success'});
            })
            .catch(err => {
                reject(err.data)
                //jwt过期跳转不弹出加载失败
                let string = err.data.request.responseURL
                if (string.indexOf('/a/login;JSESSIONID') != -1) {
                    return;
                }
                // Loading.service(true).close();
                Message({ message: '加载失败', type: 'error' });
            })
    });
}

// 封装了一个检测返回结果的函数，与后台返回状态码code === 1002表示jwt失效
let isRefreshing = true;
function checkStatus(config) {
    // 刷新jwt的函数,这需要添加一个开关，防止重复请求
    if(isRefreshing){
        refreshjwtRequst(config)
    }
    isRefreshing = false;
    // 这个Promise函数很关键---获取jwt后重新请求--暂时没法获取对应的请求方法
    const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(()=> {
            resolve(axios.request(config).then(res => res.data)
            )
        })
    });
    return retryOriginalRequest;
}
// 刷新jwt的请求函数
function refreshjwtRequst(config){
    //自动登录
    var form = {
        password: localStorage.getItem("password"),
        username: localStorage.getItem("username"),
        deviceType: "PC"
    }
    login(form).then(res => {
        isRefreshing = true;
        var userjwt = res.data.jwt;
        var permission = res.data.permissionList;
        // 将用户jwt保存到vuex中
        localStorage.setItem("Authorization", userjwt);
        axios.defaults.headers.common['jwt'] = localStorage.getItem('Authorization')
        onAccessjwtFetched();
    });
}
// Promise函数集合
let subscribers = [];
function onAccessjwtFetched() {
    subscribers.forEach((callback)=>{
        callback();
    })
    subscribers = [];
}
 
function addSubscriber(callback) {
    subscribers.push(callback)
}

// 定时刷新token
let refreshjwtTimingtag = true;
let subscribersTiming = [];
function checkjwt(config) {
    if(refreshjwtTimingtag){
        refreshjwtTiming()
    }
    // 这个Promise函数很关键---获取jwt后重新请求--暂时没法获取对应的请求方法
    const retryOriginalRequest = new Promise((resolve) => {
        addSubscriberTiming(()=> {
            resolve(axios.request(config).then(res => res.data)
            )
        })
    });
    return retryOriginalRequest;

}
function refreshjwtTiming() {
    refreshjwtTimingtag = false;
    // 获取上次刷新时间
    let lastTime = new Date(localStorage.getItem("refreshjwtTime"));
    let nowTime = new Date();
    var times = 0;
    var timeSpace = 10*60*1000
    if(lastTime){
        times = nowTime-lastTime
        if(times>timeSpace){
            let userjwt = localStorage.getItem("Authorization")
            if(userjwt){
                refreshToken(userjwt).then(res => {
                    nowTime = new Date();
                    localStorage.setItem("refreshjwtTime", nowTime);
                    refreshjwtTimingtag = true;
                    subscribersTiming = []
                    onAccessjwtFetchedTiming();
                })
            }else{
                refreshjwtTimingtag = true;
                subscribersTiming = []
            }
        }
        else {
            refreshjwtTimingtag = true;
            subscribersTiming = []
        }
    }else {
        localStorage.setItem("refreshjwtTime", nowTime)
        refreshjwtTimingtag = true;
        subscribersTiming = []
    }
}

// Promise函数集合--定时刷新token
function onAccessjwtFetchedTiming() {
    subscribersTiming.forEach((callback)=>{
        callback();
    })
    subscribersTiming = [];
}
 
function addSubscriberTiming(callback) {
    subscribersTiming.push(callback)
}


// WEBPACK FOOTER //
// ./src/http/axios.js